/* Token da página /review-query (a que o backend abre sem login para gerar o
   PDF). O backend assina um token preso àquela consulta e o põe na URL; a
   página guarda aqui e o axiosInstance envia em toda chamada, no cabeçalho
   X-Review-Token. Sem ele, as rotas do relatório respondem 401. */

let reviewToken = null;

export const setReviewToken = (token) => {
  reviewToken = token || null;
};

export const getReviewToken = () => reviewToken;
